import { HTMLAttributes, ReactNode } from 'react';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';
import { TAdvancedFormReturn } from '@/hooks/useAdvancedForm/useAdvancedForm';

export type TFormProps<TFieldValues extends FieldValues, TContext> = Omit<
  HTMLAttributes<HTMLFormElement>,
  'onSubmit'
> & {
  methods:
    | UseFormReturn<TFieldValues>
    | TAdvancedFormReturn<TFieldValues, TContext>;
  children: ReactNode;
  onSubmit: SubmitHandler<TFieldValues>;
};

const Form = <
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
>({
  methods,
  children,
  onSubmit,
  ...rest
}: TFormProps<TFieldValues, TContext>) => {
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} {...rest}>
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
